import axios from 'axios';

export const externalToken = async (token) => {
    const url = `${window.ENV.REACT_APP_SERVICES_DOMAIN}/external-service-proxy/token-services/introspecttoken`;
    return axios.post(url, { token: token });
};